import React from "react"

function createMarkup(text) {
  return { __html: text }
}

const BigQuote = ({ text, fontSize }) => (
  <div className="quote-big-wrapper">
    <p
      className="quote-big"
      style={{ fontSize }}
      dangerouslySetInnerHTML={createMarkup(text)}
    ></p>
  </div>
)

export default BigQuote
